// src/api/roles.js - CORREGIDO CON RUTAS CORRECTAS
import { apiFetch } from './index.js';

/**
 * Obtener todos los roles
 * @param {string} estado - 'all', 'active', 'inactive', 'activos', 'inactivos'
 * @returns {Promise} Lista de roles
 */
export const obtenerRoles = async (estado = 'all') => {
  try {
    console.log('📋 Obteniendo roles...', { estado });
    
    let endpoint = '/Rol';  // CORREGIDO: usar /Rol en singular
    
    // Usar endpoint específico según el estado
    if (estado === 'activos') {
      endpoint = '/Rol/activos';
    } else if (estado === 'inactivos') {
      // Si no hay endpoint específico, obtenemos todos y filtramos
      const response = await apiFetch('/Rol');
      const inactivos = response.filter(r => r.estado?.toLowerCase() === 'inactivo');
      return {
        success: true,
        data: inactivos,
        count: inactivos.length,
        message: 'Roles inactivos obtenidos exitosamente'
      };
    } else if (estado === 'active') {
      endpoint = '/Rol/activos';
    } else if (estado === 'inactive') {
      const response = await apiFetch('/Rol');
      const inactivos = response.filter(r => r.estado?.toLowerCase() === 'inactivo');
      return {
        success: true,
        data: inactivos,
        count: inactivos.length,
        message: 'Roles inactivos obtenidos exitosamente'
      };
    }
    
    const response = await apiFetch(endpoint);
    
    return {
      success: true,
      data: response,
      count: Array.isArray(response) ? response.length : 0,
      message: 'Roles obtenidos exitosamente'
    };
    
  } catch (error) {
    console.error('❌ Error obteniendo roles:', error);
    return {
      success: false,
      error: error.message,
      data: [],
      count: 0
    };
  }
};

/**
 * Obtener un rol por ID
 * @param {number} id - ID del rol
 * @returns {Promise} Datos del rol
 */
export const obtenerRolPorId = async (id) => {
  try {
    if (!id) {
      throw new Error('ID de rol es requerido');
    }
    
    console.log(`🔍 Obteniendo rol ID: ${id}`);
    
    const response = await apiFetch(`/Rol/${id}`);
    
    return {
      success: true,
      data: response,
      message: 'Rol obtenido exitosamente'
    };
    
  } catch (error) {
    console.error(`❌ Error obteniendo rol ${id}:`, error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

/**
 * Obtener rol con sus permisos
 * @param {number} id - ID del rol
 * @returns {Promise} Rol con permisos incluidos
 */
export const obtenerRolConPermisos = async (id) => {
  try {
    if (!id) {
      throw new Error('ID de rol es requerido');
    }
    
    console.log(`🔍 Obteniendo rol con permisos ID: ${id}`);
    
    const response = await apiFetch(`/Rol/${id}/con-permisos`);
    
    return {
      success: true,
      data: response,
      message: 'Rol con permisos obtenido exitosamente'
    };
    
  } catch (error) {
    console.error(`❌ Error obteniendo rol con permisos ${id}:`, error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

/**
 * Obtener rol con sus usuarios
 * @param {number} id - ID del rol
 * @returns {Promise} Rol con usuarios incluidos
 */
export const obtenerRolConUsuarios = async (id) => {
  try {
    if (!id) {
      throw new Error('ID de rol es requerido');
    }
    
    console.log(`👥 Obteniendo rol con usuarios ID: ${id}`);
    
    const response = await apiFetch(`/Rol/${id}/con-usuarios`);
    
    return {
      success: true,
      data: response,
      message: 'Rol con usuarios obtenido exitosamente'
    };
    
  } catch (error) {
    console.error(`❌ Error obteniendo rol con usuarios ${id}:`, error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

/**
 * Obtener estadísticas de un rol
 * @param {number} id - ID del rol
 * @returns {Promise} Estadísticas del rol
 */
export const obtenerEstadisticasRol = async (id) => {
  try {
    if (!id) {
      throw new Error('ID de rol es requerido');
    }
    
    console.log(`📊 Obteniendo estadísticas rol ID: ${id}`);
    
    const response = await apiFetch(`/Rol/${id}/estadisticas`);
    
    return {
      success: true,
      data: response,
      message: 'Estadísticas obtenidas exitosamente'
    };
    
  } catch (error) {
    console.error(`❌ Error obteniendo estadísticas rol ${id}:`, error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

/**
 * Verificar si un rol tiene usuarios asignados
 * @param {number} id - ID del rol
 * @returns {Promise} Resultado de la verificación
 */
export const verificarRolTieneUsuarios = async (id) => {
  try {
    if (!id) {
      throw new Error('ID de rol es requerido');
    }
    
    console.log(`🔎 Verificando si rol ID ${id} tiene usuarios`);
    
    const response = await apiFetch(`/Rol/${id}/tiene-usuarios`);
    
    const tieneUsuarios = typeof response === 'boolean' ? response : response.tieneUsuarios || false;
    
    return {
      success: true,
      tieneUsuarios: tieneUsuarios,
      message: tieneUsuarios ? 'El rol tiene usuarios asignados' : 'El rol no tiene usuarios asignados'
    };
    
  } catch (error) {
    console.error(`❌ Error verificando usuarios rol ${id}:`, error);
    return {
      success: false,
      error: error.message,
      tieneUsuarios: false
    };
  }
};

/**
 * Verificar si un rol existe por ID
 * @param {number} id - ID del rol
 * @returns {Promise} Resultado de la verificación
 */
export const verificarRolExiste = async (id) => {
  try {
    if (!id) {
      throw new Error('ID es requerido');
    }
    
    console.log(`🔎 Verificando si rol ID ${id} existe`);
    
    const response = await apiFetch(`/Rol/${id}/exists`);
    
    const existe = typeof response === 'boolean' ? response : response.existe || false;
    
    return {
      success: true,
      existe: existe,
      message: existe ? 'El rol existe' : 'El rol no existe'
    };
    
  } catch (error) {
    console.error(`❌ Error verificando rol ${id}:`, error);
    return {
      success: false,
      error: error.message,
      existe: false
    };
  }
};

/**
 * Verificar si un nombre de rol ya existe
 * @param {string} nombre - Nombre a verificar
 * @returns {Promise} Resultado de la verificación
 */
export const verificarNombreRol = async (nombre) => {
  try {
    if (!nombre || nombre.trim() === '') {
      throw new Error('Nombre es requerido');
    }
    
    console.log(`🔎 Verificando nombre de rol: "${nombre}"`);
    
    const response = await apiFetch(`/Rol/validar-nombre?nombre=${encodeURIComponent(nombre)}`);
    
    const existe = typeof response === 'boolean' ? response : response.existe || false;
    
    return {
      success: true,
      existe: existe,
      disponible: !existe,
      message: existe ? 'El nombre ya existe' : 'Nombre disponible'
    };
    
  } catch (error) {
    console.error(`❌ Error verificando nombre "${nombre}":`, error);
    return {
      success: false,
      error: error.message,
      existe: false,
      disponible: false
    };
  }
};

/**
 * Obtener roles por permiso
 * @param {number} idPermiso - ID del permiso
 * @returns {Promise} Lista de roles que tienen el permiso
 */
export const obtenerRolesPorPermiso = async (idPermiso) => {
  try {
    if (!idPermiso) {
      throw new Error('ID de permiso es requerido');
    }
    
    console.log(`🔍 Obteniendo roles con permiso ID: ${idPermiso}`);
    
    const response = await apiFetch(`/Rol/por-permiso/${idPermiso}`);
    
    return {
      success: true,
      data: response,
      count: Array.isArray(response) ? response.length : 0,
      message: 'Roles por permiso obtenidos exitosamente'
    };
    
  } catch (error) {
    console.error(`❌ Error obteniendo roles por permiso ${idPermiso}:`, error);
    return {
      success: false,
      error: error.message,
      data: [],
      count: 0
    };
  }
};

/**
 * Crear un nuevo rol
 * @param {Object} rolData - Datos del rol (nombre, descripcion, estado, idPermisos)
 * @returns {Promise} Rol creado
 */
export const crearRol = async (rolData) => {
  try {
    // Validar datos requeridos
    if (!rolData.nombre || rolData.nombre.trim() === '') {
      throw new Error('El nombre es requerido');
    }
    
    console.log('➕ Creando nuevo rol:', rolData);
    
    const body = {
      nombre: rolData.nombre.trim(),
      descripcion: rolData.descripcion || null,
      estado: rolData.estado || 'activo'
    };
    
    // Si se proporcionan permisos, incluirlos
    if (rolData.idPermisos && Array.isArray(rolData.idPermisos) && rolData.idPermisos.length > 0) {
      body.idPermisos = rolData.idPermisos;
    }
    
    const response = await apiFetch('/Rol', {
      method: 'POST',
      body: JSON.stringify(body)
    });
    
    return {
      success: true,
      data: response,
      message: 'Rol creado exitosamente'
    };
    
  } catch (error) {
    console.error('❌ Error creando rol:', error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

/**
 * Actualizar un rol existente
 * @param {number} id - ID del rol
 * @param {Object} rolData - Datos a actualizar
 * @returns {Promise} Rol actualizado
 */
export const actualizarRol = async (id, rolData) => {
  try {
    if (!id) {
      throw new Error('ID de rol es requerido');
    }
    
    console.log(`✏️ Actualizando rol ID: ${id}`, rolData);
    
    const body = {
      nombre: rolData.nombre?.trim(),
      descripcion: rolData.descripcion || null,
      estado: rolData.estado || 'activo'
    };
    
    const response = await apiFetch(`/Rol/${id}`, {
      method: 'PUT',
      body: JSON.stringify(body)
    });
    
    return {
      success: true,
      data: response,
      message: 'Rol actualizado exitosamente'
    };
    
  } catch (error) {
    console.error(`❌ Error actualizando rol ${id}:`, error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

/**
 * Eliminar un rol
 * @param {number} id - ID del rol a eliminar
 * @returns {Promise} Resultado de la eliminación
 */
export const eliminarRol = async (id) => {
  try {
    if (!id) {
      throw new Error('ID de rol es requerido');
    }
    
    console.log(`🗑️ Eliminando rol ID: ${id}`);
    
    const response = await apiFetch(`/Rol/${id}`, {
      method: 'DELETE'
    });
    
    return {
      success: true,
      data: response,
      message: 'Rol eliminado exitosamente'
    };
    
  } catch (error) {
    console.error(`❌ Error eliminando rol ${id}:`, error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

/**
 * Cambiar estado de un rol (activo/inactivo)
 * @param {Object} data - Datos para cambio de estado
 * @returns {Promise} Resultado del cambio de estado
 */
export const cambiarEstadoRol = async (data) => {
  try {
    const { idRol, estado } = data;
    
    if (!idRol || !estado) {
      throw new Error('ID y estado son requeridos');
    }
    
    console.log(`🔄 Cambiando estado de rol ID: ${idRol} a ${estado}`);
    
    const response = await apiFetch('/Rol/cambiar-estado', {
      method: 'PATCH',
      body: JSON.stringify({
        idRol: idRol,
        estado: estado
      })
    });
    
    return {
      success: true,
      data: response,
      message: 'Estado de rol actualizado exitosamente'
    };
    
  } catch (error) {
    console.error(`❌ Error cambiando estado de rol:`, error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

/**
 * Asignar permisos a un rol
 * @param {Object} data - Datos de asignación
 * @returns {Promise} Resultado de la asignación
 */
export const asignarPermisosARol = async (data) => {
  try {
    const { idRol, idPermisos } = data;
    
    if (!idRol || !idPermisos || !Array.isArray(idPermisos)) {
      throw new Error('ID de rol y lista de permisos son requeridos');
    }
    
    console.log(`🔗 Asignando ${idPermisos.length} permisos al rol ID: ${idRol}`);
    
    const response = await apiFetch('/Rol/asignar-permisos', {
      method: 'POST',
      body: JSON.stringify({
        idRol: idRol,
        idPermisos: idPermisos
      })
    });
    
    return {
      success: true,
      data: response,
      message: 'Permisos asignados exitosamente'
    };
    
  } catch (error) {
    console.error(`❌ Error asignando permisos al rol:`, error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

/**
 * Quitar permisos de un rol
 * @param {Object} data - Datos de desasignación
 * @returns {Promise} Resultado de la desasignación
 */
export const quitarPermisosDeRol = async (data) => {
  try {
    const { idRol, idPermisos } = data;
    
    if (!idRol || !idPermisos || !Array.isArray(idPermisos)) {
      throw new Error('ID de rol y lista de permisos son requeridos');
    }
    
    console.log(`🔗 Quitando ${idPermisos.length} permisos del rol ID: ${idRol}`);
    
    const response = await apiFetch('/Rol/quitar-permisos', {
      method: 'POST',
      body: JSON.stringify({
        idRol: idRol,
        idPermisos: idPermisos
      })
    });
    
    return {
      success: true,
      data: response,
      message: 'Permisos quitados exitosamente'
    };
    
  } catch (error) {
    console.error(`❌ Error quitando permisos del rol:`, error);
    return {
      success: false,
      error: error.message,
      data: null
    };
  }
};

// ==================== FUNCIONES AUXILIARES (NO API) ====================

/**
 * Formatear fecha de rol
 * @param {string} fechaISO - Fecha en formato ISO
 * @param {boolean} completo - Si incluir hora completa
 * @returns {string} Fecha formateada
 */
export const formatearFechaRol = (fechaISO, completo = false) => {
  if (!fechaISO) return 'N/A';
  
  try {
    const fecha = new Date(fechaISO);
    const opciones = {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    };
    
    if (completo) {
      opciones.hour = '2-digit';
      opciones.minute = '2-digit';
    }
    
    return fecha.toLocaleDateString('es-ES', opciones);
  } catch (error) {
    return fechaISO;
  }
};

/**
 * Convertir estado a texto legible
 * @param {string} estado - Estado del rol
 * @returns {string} Estado formateado
 */
export const convertirEstadoATexto = (estado) => {
  if (!estado) return 'Sin estado';
  return estado.charAt(0).toUpperCase() + estado.slice(1);
};

/**
 * Convertir estado a booleano (activo = true)
 * @param {string} estado - Estado como string
 * @returns {boolean} Estado booleano
 */
export const convertirEstadoABoolean = (estado) => {
  return estado?.toLowerCase() === 'activo';
};

/**
 * Buscar roles por término
 * @param {Array} roles - Lista de roles
 * @param {string} termino - Término de búsqueda
 * @returns {Array} Roles filtrados
 */
export const buscarRoles = (roles, termino) => {
  if (!termino || termino.trim() === '') {
    return roles;
  }
  
  const terminoLower = termino.toLowerCase();
  return roles.filter(rol => 
    rol.nombre?.toLowerCase().includes(terminoLower) ||
    rol.descripcion?.toLowerCase().includes(terminoLower)
  );
};

/**
 * Filtrar roles por estado
 * @param {Array} roles - Lista de roles
 * @param {string} estado - 'all', 'active', 'inactive', 'activos', 'inactivos'
 * @returns {Array} Roles filtrados
 */
export const filtrarRolesPorEstado = (roles, estado) => {
  if (estado === 'all') return roles;
  if (estado === 'active' || estado === 'activos') return roles.filter(r => r.estado?.toLowerCase() === 'activo');
  if (estado === 'inactive' || estado === 'inactivos') return roles.filter(r => r.estado?.toLowerCase() === 'inactivo');
  return roles;
};

/**
 * Obtener estadísticas de roles
 * @param {Array} roles - Lista de roles
 * @returns {Object} Estadísticas
 */
export const obtenerEstadisticasRoles = (roles) => {
  const activos = roles.filter(r => r.estado?.toLowerCase() === 'activo').length;
  const inactivos = roles.filter(r => r.estado?.toLowerCase() === 'inactivo').length;
  const conPermisos = roles.filter(r => (r.permisos?.length || 0) > 0).length;
  const totalUsuarios = roles.reduce((sum, r) => sum + (r.usuarios?.length || 0), 0);
  
  return {
    total: roles.length,
    activos,
    inactivos,
    porcentajeActivos: roles.length > 0 ? Math.round((activos / roles.length) * 100) : 0,
    porcentajeInactivos: roles.length > 0 ? Math.round((inactivos / roles.length) * 100) : 0,
    conPermisos,
    porcentajeConPermisos: roles.length > 0 ? Math.round((conPermisos / roles.length) * 100) : 0,
    totalUsuarios,
    promedioUsuarios: roles.length > 0 ? (totalUsuarios / roles.length).toFixed(1) : 0
  };
};

/**
 * Ordenar roles alfabéticamente
 * @param {Array} roles - Lista de roles
 * @param {string} direccion - 'asc' o 'desc'
 * @returns {Array} Roles ordenados
 */
export const ordenarRoles = (roles, direccion = 'asc') => {
  const rolesCopy = [...roles];
  
  return rolesCopy.sort((a, b) => {
    const nombreA = a.nombre?.toLowerCase() || '';
    const nombreB = b.nombre?.toLowerCase() || '';
    
    if (direccion === 'asc') {
      return nombreA.localeCompare(nombreB);
    } else {
      return nombreB.localeCompare(nombreA);
    }
  });
};

/**
 * Agrupar roles por estado
 * @param {Array} roles - Lista de roles
 * @returns {Object} Roles agrupados
 */
export const agruparRolesPorEstado = (roles) => {
  return {
    activos: roles.filter(r => r.estado?.toLowerCase() === 'activo'),
    inactivos: roles.filter(r => r.estado?.toLowerCase() === 'inactivo')
  };
};

// ==================== FUNCIONES DE EXPORTACIÓN ====================

/**
 * Exportar roles a Excel (requiere xlsx instalado)
 * @param {Array} roles - Lista de roles
 * @param {string} filename - Nombre del archivo (sin extensión)
 * @returns {Object} Resultado de la exportación
 */
export const exportarExcel = (roles, filename = 'roles') => {
  try {
    if (typeof window === 'undefined') {
      return { success: false, error: 'Exportación solo disponible en el navegador' };
    }
    
    const XLSX = require('xlsx');
    const wb = XLSX.utils.book_new();
    
    const data = roles.map(rol => ({
      'ID': rol.idRol || '',
      'Nombre': rol.nombre || '',
      'Descripción': rol.descripcion || 'Sin descripción',
      'Estado': convertirEstadoATexto(rol.estado),
      'Fecha Creación': formatearFechaRol(rol.fecha_creacion || rol.fechaCreacion, true),
      'Permisos': (rol.permisos?.length || 0),
      'Usuarios': (rol.usuarios?.length || 0)
    }));
    
    const ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Roles');
    
    const fecha = new Date();
    const fechaStr = fecha.toISOString().split('T')[0];
    const nombreArchivo = `${filename}_${fechaStr}.xlsx`;
    
    XLSX.writeFile(wb, nombreArchivo);
    
    return {
      success: true,
      filename: nombreArchivo,
      message: `Archivo ${nombreArchivo} generado exitosamente`,
      count: roles.length
    };
    
  } catch (error) {
    console.error('❌ Error exportando a Excel:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Exportar roles a PDF (requiere jspdf y jspdf-autotable instalados)
 * @param {Array} roles - Lista de roles
 * @param {string} title - Título del documento
 * @returns {Object} Resultado de la exportación
 */
export const exportarPDF = (roles, title = 'Reporte de Roles') => {
  try {
    if (typeof window === 'undefined') {
      return { success: false, error: 'Exportación solo disponible en el navegador' };
    }
    
    const { jsPDF } = require('jspdf');
    require('jspdf-autotable');
    
    const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const fecha = new Date();
    const fechaStr = fecha.toLocaleDateString('es-ES', {
      year: 'numeric', month: 'long', day: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
    
    // Título
    doc.setFontSize(20);
    doc.setFont('helvetica', 'bold');
    doc.text(title, pageWidth / 2, 20, { align: 'center' });
    
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(`Generado: ${fechaStr}`, pageWidth / 2, 28, { align: 'center' });
    
    // Estadísticas
    const stats = obtenerEstadisticasRoles(roles);
    doc.setFontSize(12);
    doc.text('Resumen Estadístico', 14, 40);
    doc.setFontSize(10);
    doc.text(`• Total de roles: ${stats.total}`, 16, 48);
    doc.text(`• Roles activos: ${stats.activos} (${stats.porcentajeActivos}%)`, 16, 54);
    doc.text(`• Roles inactivos: ${stats.inactivos} (${stats.porcentajeInactivos}%)`, 16, 60);
    doc.text(`• Total de permisos asignados: ${stats.totalUsuarios}`, 16, 66);
    
    // Tabla
    const tableData = roles.map(rol => [
      rol.idRol || '',
      rol.nombre || '',
      rol.descripcion?.substring(0, 50) + (rol.descripcion?.length > 50 ? '...' : '') || 'Sin descripción',
      convertirEstadoATexto(rol.estado),
      formatearFechaRol(rol.fecha_creacion || rol.fechaCreacion),
      (rol.permisos?.length || 0)
    ]);
    
    doc.autoTable({
      startY: 75,
      head: [['ID', 'Nombre', 'Descripción', 'Estado', 'Fecha', 'Permisos']],
      body: tableData,
      theme: 'striped',
      headStyles: { fillColor: [41, 128, 185], textColor: [255, 255, 255], fontStyle: 'bold' },
      styles: { fontSize: 8, cellPadding: 3 },
      didDrawPage: function(data) {
        doc.setFontSize(8);
        doc.setTextColor(128, 128, 128);
        doc.text(`Página ${data.pageNumber}`, pageWidth / 2, pageHeight - 10, { align: 'center' });
      }
    });
    
    const fechaArchivo = fecha.toISOString().split('T')[0];
    const nombreArchivo = `reporte_roles_${fechaArchivo}.pdf`;
    doc.save(nombreArchivo);
    
    return {
      success: true,
      filename: nombreArchivo,
      message: `Documento ${nombreArchivo} generado exitosamente`,
      count: roles.length
    };
    
  } catch (error) {
    console.error('❌ Error exportando a PDF:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Exportar reporte completo (Excel + PDF)
 * @param {Array} roles - Lista de roles
 * @param {string} baseFilename - Nombre base del archivo
 * @returns {Promise} Resultado de la exportación
 */
export const exportarReporteCompleto = async (roles, baseFilename = 'reporte_completo_roles') => {
  try {
    if (roles.length === 0) {
      throw new Error('No hay datos para exportar');
    }
    
    const excelResult = exportarExcel(roles, baseFilename);
    if (!excelResult.success) throw new Error(`Error en Excel: ${excelResult.error}`);
    
    await new Promise(resolve => setTimeout(resolve, 500));
    
    const pdfResult = exportarPDF(roles, `Reporte de Roles - ${baseFilename}`);
    if (!pdfResult.success) throw new Error(`Error en PDF: ${pdfResult.error}`);
    
    return {
      success: true,
      excel: excelResult,
      pdf: pdfResult,
      message: 'Reporte completo generado exitosamente',
      count: roles.length
    };
    
  } catch (error) {
    console.error('❌ Error exportando reporte completo:', error);
    return { success: false, error: error.message };
  }
};

// ==================== EXPORT DEFAULT ====================

export default {
  // Funciones API
  obtenerRoles,
  obtenerRolPorId,
  obtenerRolConPermisos,
  obtenerRolConUsuarios,
  obtenerEstadisticasRol,
  verificarRolTieneUsuarios,
  verificarRolExiste,
  verificarNombreRol,
  obtenerRolesPorPermiso,
  crearRol,
  actualizarRol,
  eliminarRol,
  cambiarEstadoRol,
  asignarPermisosARol,
  quitarPermisosDeRol,
  
  // Funciones auxiliares
  formatearFechaRol,
  convertirEstadoATexto,
  convertirEstadoABoolean,
  buscarRoles,
  filtrarRolesPorEstado,
  obtenerEstadisticasRoles,
  ordenarRoles,
  agruparRolesPorEstado,
  
  // Funciones de exportación
  exportarExcel,
  exportarPDF,
  exportarReporteCompleto
};